var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
function SvgFeat3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#58F2A9",
    fillOpacity: 0.15
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25 25L19 19M7 14C7 14.9193 7.18106 15.8295 7.53284 16.6788C7.88463 17.5281 8.40024 18.2997 9.05025 18.9497C9.70026 19.5998 10.4719 20.1154 11.3212 20.4672C12.1705 20.8189 13.0807 21 14 21C14.9193 21 15.8295 20.8189 16.6788 20.4672C17.5281 20.1154 18.2997 19.5998 18.9497 18.9497C19.5998 18.2997 20.1154 17.5281 20.4672 16.6788C20.8189 15.8295 21 14.9193 21 14C21 13.0807 20.8189 12.1705 20.4672 11.3212C20.1154 10.4719 19.5998 9.70026 18.9497 9.05025C18.2997 8.40024 17.5281 7.88463 16.6788 7.53284C15.8295 7.18106 14.9193 7 14 7C13.0807 7 12.1705 7.18106 11.3212 7.53284C10.4719 7.88463 9.70026 8.40024 9.05025 9.05025C8.40024 9.70026 7.88463 10.4719 7.53284 11.3212C7.18106 12.1705 7 13.0807 7 14Z",
    stroke: "#1ED760",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeat3);
export default __webpack_public_path__ + "static/media/feat3.5be597a35fbd3f22a3551d1346109f96.svg";
export { ForwardRef as ReactComponent };